import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../services/workplace.service';
import {
    InsuranceCompanyGridItemObject,
    InsuranceCompanyGridObject,
    ServicePaymentGridItemObject,
    ServicePaymentGridObject,
    WorkplaceIcpGridObject,
} from '@it2go/types';
import { InsuranceCompanyGqlService } from '../../../../../services/insurance-company.gql-service';
import { ServiceService } from '../../../../../services/service.service';

interface State {
    workplaceIcps: WorkplaceIcpGridObject | null;
    insuranceCompanies: InsuranceCompanyGridObject | null;
    servicePayments: ServicePaymentGridObject | null;
}

const defaultState: State = {
    workplaceIcps: null,
    insuranceCompanies: null,
    servicePayments: null,
};

@Injectable()
export class WorkplaceDetailIcpsStore extends ComponentStoreFactory<State> {

    insuranceCompanies$ = this.data.insuranceCompanies$.gridItems<InsuranceCompanyGridItemObject>();
    servicePayments$ = this.data.servicePayments$.gridItems<ServicePaymentGridItemObject>();

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService), inject(InsuranceCompanyGqlService), inject(ServiceService));
    }

}
